import React from "react";

import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { GetApp } from "@mui/icons-material";
import Moment from "moment";

import { ButtonContactGreen } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const ExcelClientListReportOperators = ({ excelData, fileName, disabled }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const fileExtension = ".xlsx";
  let transformedData = [];

  const columnHeaders = {
    codigo: "Código",
    nombres: "Nombres",
    apellidos: "Apellidos",
    nombre_completo: "Cliente",
    documento: "Documento",
    email: "Email",
    registro: "Inicio de Vigencia",
    producto: "Producto",
    caracteristica: "Caracteristica",
    pago: "Pago",
    sub_Total: "Sub total",
    iva_Total: "IVA total",
    pago_Total: "Pago total",
    iva_porcentaje: "IVA %",
    operador: "Gestor",
    comision_operador: "Comisión gestor",
    tipo_pago: "Forma de pago",
  };

  // CREAR LA LISTA CON EL MAPEADO
  if (excelData.length > 0) {
    transformedData = excelData.map((item) => {
      let caracteristicas = item.productsJson[0].prices.find(
        (data) => data.price === item.productsJson[0].priceSelect
      );

      const commissionPercentage = parseFloat(item.commissionPercentageUser);
      const payTotal =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].payMonthTotal)
          : parseFloat(item.productsJson[0].payTotal);

      // Cálculo de la comisión
      const percentage =
        isNaN(commissionPercentage) || isNaN(payTotal)
          ? 0
          : (commissionPercentage * payTotal) / 100;

      // Creamos un objeto vacío para cada fila
      const row = {};

      // Ahora llenamos el resto de los campos en `row`
      row.codigo = item.code;
      row.nombres = `${item.client.name1} ${item.client.name2}`;
      row.apellidos = `${item.client.lastName1} ${item.client.lastName2}`;
      row.nombre_completo = item.client.allNames;
      row.documento = item.client.documentId;
      row.email = item.client.email;
      row.registro = Moment(item.createdAt).format("YYYY-MM-DD");
      row.producto = item.productsJson[0].name;
      row.caracteristica = caracteristicas.name;
      row.pago =
        item.productsJson[0].typePay === "CR"
          ? "COBRO RECURRENTE"
          : item.productsJson[0].periodo;
      row.sub_Total =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].subMonthTotal)
          : parseFloat(item.productsJson[0].subTotal);
      row.iva_Total =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].ivaMonthTotal)
          : parseFloat(item.productsJson[0].ivaTotal);
      row.pago_Total =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].payMonthTotal)
          : parseFloat(item.productsJson[0].payTotal);
      row.iva_porcentaje =
        parseFloat(item.productsJson[0].ivaTotal) === 0
          ? 0
          : item.productsJson[0].iva;
      row.operador = item.user.allNames;
      row.comision_operador = parseFloat(percentage.toFixed(2));
      row.tipo_pago =
        item.productsJson[0].typePay === "E"
          ? "EFECTIVO"
          : "TARJETA DE CREDITO";

      // Mapeamos los encabezados con los valores correspondientes
      const mappedRow = Object.keys(row).reduce((acc, key) => {
        acc[columnHeaders[key] || key] = row[key];
        return acc;
      }, {});

      return mappedRow;
    });
  }

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      {/*<Tooltip title={fileName}>*/}
      <ButtonContactGreen
        onClick={(e) => exportToExcel(fileName)}
        // className={className}
        startIcon={<GetApp style={{ fontSize: 14 }} />}
        disabled={disabled}
        style={{
          fontSize: 12,
        }}
      >
        {" "}
        Excel
      </ButtonContactGreen>
      {/*</Tooltip>*/}
    </>
  );
};

export default ExcelClientListReportOperators;
